<form [formGroup]="sendMail" (ngSubmit)="onSubmitsendMail()">
    <div class="row">
        <div class="col-md-10">
            <div class="form-group">
                <label for="username">EmailAddress:</label>
                <input type="text" id="sendEmail" formControlName="sendEmail" class="form-control">
                <div class="text-danger"
                        *ngIf="sendMail.get('sendEmail').invalid && (sendMail.get('sendEmail').dirty || sendMail.get('sendEmail').touched)">
                        <div *ngIf="sendMail.get('sendEmail').errors?.['required']">Email is required.</div>
                        <div *ngIf="sendMail.get('sendEmail').errors?.['pattern']">Invalid email address.</div>
                    </div>
            </div>

        </div>
        <div class="col-md-2 mt-2">
            <button type="button" (click)="onSubmitsendMail()" [disabled]="isLoadingTest$ | async" class="btn btn-primary mt-4">
                <span *ngIf="!isAuthLoadingTest">Send</span>
            <span *ngIf="isAuthLoadingTest">sending...</span>
            <img *ngIf="isLoadingTest$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
            </button>

        </div>

    </div>

</form>
